import { Component, OnDestroy, inject } from "@angular/core";
import { SpinnerService, SpinnerState } from "@app/core/spinner/spinner.service";
import { Subscription } from "rxjs";

/* export enum SpinnerTypes {
	CHASING_DOTS,
	CIRCLE,
	CUBE_GRID,
	DOUBLE_BOUNCE,
	FADING_CIRCLE,
	FOLDING_CUBE,
	PULSE,
	ROTATING_PLANE,
	THREE_BOUNCE,
	WANDERING_CUBES,
	WAVE,
	WORD_PRESS
} */

@Component({
	selector: "app-spinner",
	templateUrl: "./spinner.component.html",
	styleUrl: "./spinner.component.scss",
	standalone: false
})
export class SpinnerComponent implements OnDestroy {
	private spinnerService = inject(SpinnerService);

	protected baseClass = "three-bounce-spinner";
	protected childClass = "bounce";
	protected items = new Array(3);
	protected visible = false;

	private spinnerStateChanged: Subscription;
	constructor() {
		this.spinnerStateChanged = this.spinnerService.spinnerState
			.subscribe((state: SpinnerState) => {
				this.visible = state.show.valueOf();
			});
	}

	ngOnDestroy(): any {
		this.spinnerStateChanged.unsubscribe();
	}
}